import { Component, OnInit } from '@angular/core';
import { NgxMasonryOptions } from "ngx-masonry";
import AppShareHelper from "../../utils/helper";
import { ToastrService } from "ngx-toastr";
import { ActivatedRoute, Router } from "@angular/router";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { UserService } from "../../../modules/user/services/user.service";
import { Lightbox } from "ngx-lightbox";
import { ContactPopupComponent } from "./contact-popup/contact-popup..component";
import { Meta } from '@angular/platform-browser';
import * as _ from 'lodash';

@Component({
    selector: 'app-user-page-public',
    templateUrl: './user-page-public.component.html'
})
export class UserPagePublicComponent implements OnInit {
    constructor(protected toastr: ToastrService,
                protected route: ActivatedRoute,
                protected _modalService: NgbModal,
                protected userService: UserService,
                protected lightbox: Lightbox,
                protected router: Router,
                private meta: Meta) {
    }
    
    bioInfo: any = {};
    photos = [];
    
    ngOnInit() {
        this.meta.updateTag({ property: 'og:title', content: 'hello abc' });
        
        if (this.route.snapshot.params.id) {
            this.userService.getUserBio(this.route.snapshot.params.id).toPromise().then((res: any) => {
                this.bioInfo = res.Data;
                this.meta.updateTag({ property: 'og:title', content: this.bioInfo.description });
                if (this.bioInfo.photos.length) {
                    _.remove( this.bioInfo.photos, (item) => {
                        return !item
                    } )
                    
                }
                this.photos = this.bioInfo.photos;
            }).catch((res) => {
                this.router.navigate(['/not-found-page']);
            })
        }
    }
    
    public renderImageOptions: NgxMasonryOptions = {
        transitionDuration: '1s',
        itemSelector: '.grid-item',
        horizontalOrder: false,
    };
    
    calculateImageSize(photo) {
        return AppShareHelper.calculateImageSizeForFluidContainer(photo);
    }
    
    trackByFn(index, item) {
        return item.id;
    }
    
    viewDetail(photo) {
        this.lightbox.open(
            [{
                src: photo.original,
                caption: photo.title,
                thumb: photo.thumbnail
            }],
            0);
    }
    
    viewContact() {
        // @ts-ignore
        const modalRef = this._modalService.open(ContactPopupComponent, {
            centered: true,
            size: "md"
        });
        
        modalRef.componentInstance.fullName = this.bioInfo.fullName;
        modalRef.componentInstance.email = this.bioInfo.email || 'N/A';
        modalRef.componentInstance.phone = this.bioInfo.phone || 'N/A';
    }
}

